import React from 'react'
import { Container } from './styles'

interface ToggleProps {
    title?: string
    headerComponent?: JSX.Element
    name: string
    value: boolean
    onChange: (event: Event) => void
}
const Toggle = ({ title, headerComponent, name, value = false, onChange }: ToggleProps): JSX.Element => {
    return (
        <Container>
            <div className='row_header'>
                {!title && headerComponent ? <div className={'toggle_label'}>{headerComponent}</div> : null }
            </div>
            <div className='row_body'>
                <label className="toggle_switch">
                    <input
                        className={'toggle_input'}
                        onChange={() => onChange({target: {value: !value, name: name}})}
                        defaultChecked={value}
                        checked={value}
                        type="checkbox"
                    />
                    <span className="toggle_slider"></span>
                </label>
                {title ? <label className={'toggle_label'}>{title}</label> : null}
            </div>
            
        </Container>
    )
}

export default Toggle
